import {ADD_FOLLOWING } from './types';

export default {
  [ADD_FOLLOWING]: (state, payload) => {
    state.following = [...state.following, payload.following];
  },

};